import { Component, Input, OnInit } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { JobStatusToIcon } from '@y42/job';
import { JobStatus } from '@y42/json-schema';
import { Diagram } from 'gojs';
import { clearPropertyValueOnModel } from '@y42/gojs';
import { OrchestrationNodeBindings } from '../models/orchestration-diagram.model';

@Component({
  selector: 'y42-orchestration-node-status-filter[diagram]',
  templateUrl: './orchestration-node-status-filter.component.html',
  styleUrls: ['./orchestration-node-status-filter.component.scss'],
})
export class OrchestrationNodeStatusFilterComponent implements OnInit {
  @Input() diagram!: Diagram;

  readonly JobStatus = JobStatus;
  readonly JobStatusToIcon = JobStatusToIcon;

  filterStatus: JobStatus | 'all' = 'all';

  statusTypes = {
    valid: {
      value: JobStatus.Ready,
      count: 0,
    },
    invalid: {
      value: JobStatus.Invalid,
      count: 0,
    },
    pending: {
      value: JobStatus.Pending,
      count: 0,
    },
  };

  ngOnInit(): void {
    this.diagram.addModelChangedListener(() => {
      const validNodes = this.diagram.findNodesByExample({
        [OrchestrationNodeBindings.JobStatus]: JobStatus.Ready,
      });
      const inValidNodes = this.diagram.findNodesByExample({
        [OrchestrationNodeBindings.JobStatus]: JobStatus.Invalid,
      });
      const pendingNodes = this.diagram.findNodesByExample({
        [OrchestrationNodeBindings.JobStatus]: JobStatus.Pending,
      });

      this.statusTypes.valid.count = validNodes.count;
      this.statusTypes.invalid.count = inValidNodes.count;
      this.statusTypes.pending.count = pendingNodes.count;
    });
  }

  onStatusFilterChanged({ value }: MatButtonToggleChange) {
    clearPropertyValueOnModel(this.diagram, OrchestrationNodeBindings.Filtered, true);
    if (value === 'all') {
      return;
    }
    const filteredNodes = this.diagram.findNodesByExample({ [OrchestrationNodeBindings.JobStatus]: value });
    this.diagram.model.commit((m) => {
      while (filteredNodes.next()) {
        m.set(filteredNodes.value.data, OrchestrationNodeBindings.Filtered, true);
      }
    });

    if (filteredNodes.count > 0) {
      this.diagram.commandHandler.scrollToPart(filteredNodes.first()!);
    }
  }
}
